import NextImage, { type ImageProps } from "next/image";

/** Thin wrapper around next/image with 3G-friendly defaults. */
export default function OptimizedImage(props: ImageProps) {
  return (
    <NextImage
      quality={props.quality ?? 65}
      loading={props.priority ? undefined : (props.loading ?? "lazy")}
      {...props}
    />
  );
}
